import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'

import { sizes } from '@qflow/theme'
import { ColourButton, icons, Label, Spacer } from 'portal/lib/primitives'

export function AddButton({ children = 'Add', iconOnly = false, ...props }) {
  if (iconOnly) {
    return (
      <Tooltip title={children}>
        <ColourButton.Basic
          style={{ padding: '4px 8px 4px 9px', minWidth: '32px' }}
          {...props}
        >
          <icons.Plus size={sizes.SMALL} />
        </ColourButton.Basic>
      </Tooltip>
    )
  }

  return (
    <ColourButton.Basic {...props}>
      <icons.Plus size={sizes.SMALL} />

      <Spacer.Fine />

      <Label isChild colour="inherit">
        {children}
      </Label>
    </ColourButton.Basic>
  )
}

AddButton.propTypes = {
  ...ColourButton.Basic.propTypes,
  children: PropTypes.string
}
